// import clearLoad from "./scaleLoading.js"; 
// SCALE PLATFORM 
// | Especially use for Web Platform 3.0 / 2022
// | Although WP3.2.3 is preventing non-responsive design, there still have some
// | unexpected input PSD from outsource, out-dated designers.

import configJSON from '../../../config.js';

$(window).on("load", function () {
    if (!varMS.H5) return;

    // let layerRotateDiv = document.createElement("div");
    // layerRotateDiv.className = "rotate-phone";

    // let imageElement = document.createElement("img");
    // imageElement.src = "https://cdn-mainsite-aka.vnggames.com/products/metalslug/item-loading/layerRotate.gif";

    // layerRotateDiv.appendChild(imageElement);
    // document.body.appendChild(layerRotateDiv);
});


// const { observe } = require("./setup");

var config = {
    widthTriggerScale: 9999,
    widthDesktopSafe: 1620,
    widthDesktop: varMS.scaleWidthPC,
    widthMobile: varMS.scaleWidthMB,
    heightDesktop: 1000,
    heightMobile: 1000,
    func: {
        isMobile: function () {
            if (varMS.onlyPC) return false;
            var device = {
                width: $(window).innerWidth(),
                height: $(window).innerHeight()
            };

            return ((device.width <= config.widthMobile) && (device.width <= device.height));
        }
    }
}

$.fn.scalePlatform = function (callback) {
    var defaults = {
        obj: $(this),
        designSafe: {
            // if width of device smaller safe zone, then init scale. 
            desktop: config.widthTriggerScale,
            mobile: config.widthTriggerScale
        },
        designWidth: {
            desktop: config.widthDesktop,
            mobile: config.widthMobile
        },
        designHeight: {
            desktop: config.heightDesktop,
            mobile: config.heightMobile
        },
        mode: '', //scaleForWidth
        elScale: {
            desktop: ".scaleDesktop",
            mobile: ".scaleMobile"
        },
        dataScale: "data-scale-ratio",
        dataDevice: "data-device-type",
        dataDisplay: {
            desktop: "data-desktop-display",
            mobile: "data-mobile-display",
        },
        dataOrigin: {
            desktop: "data-desktop-origin",
            mobile: "data-mobile-origin",
        },
        rescaleForParent: true,
        deviceHeightStyleTag: {
            fix: "fixDeviceHeight",
            max: "maxDeviceHeight"
        },
        deviceHeightStyleVar: "--sr-device-height",
        deviceScaleRatioStyleVar: "--sr-scale-ratio"
    }
    var settings = $.extend(defaults, {});


    var setToDefault = function () {
        $(settings.obj).attr("style", "");
        $(settings.obj).parent().attr("style", "");
        $(settings.elScale.desktop + " , " + settings.elScale.mobile).each(function () {
            $(this).attr("style", "");
        });
        $(settings.obj).parent().attr(settings.dataScale, 1);

        // console.log('set to default');
    }();

    var device = {
        width: $(window).outerWidth(),
        height: $(window).innerHeight()
    };

    var isMobile = (width = device.width, height = device.height) => {
        if (varMS.onlyPC) return false;
        return ((width <= 768) && (width <= height));
    };

    var scaleRatio, marginLeft;
    if (varMS.H5) {
        if (!config.func.isMobile()) {
            $('.rotate-phone').css({
                opacity: 0,
                zIndex: -10000,
            });
        } else {
            $(".rotate-phone").css({
                opacity: 1,
                zIndex: 10000,
            });
        };
        if (device.width / device.height > 2) {
            scaleRatio = isMobile()
                ? device.height / settings.designHeight.mobile
                : device.height / settings.designHeight.desktop,
                marginLeft = 0;

        } else {
            scaleRatio = isMobile()
                ? device.width / settings.designWidth.mobile
                : device.width / settings.designWidth.desktop,
                marginLeft = 0;

        };
    } else {
        scaleRatio = (isMobile()) ?
            device.width / settings.designWidth.mobile :
            device.width / settings.designWidth.desktop,
            marginLeft = 0;
    };

    if (settings.deviceHeightStyleTag != false && $("#deviceHeightStyleTag").length < 1) {
        var rescaledHeight = "calc(100vh * " + 1 / scaleRatio + ")";
        var styleTag = $(`
            <style id="deviceHeightStyleTag">
                .${settings.deviceHeightStyleTag.max} {
                    max-height: ${rescaledHeight}
                }
                .${settings.deviceHeightStyleTag.fix} {
                    height: ${rescaledHeight}
                }
            </style>
        `);
        $('html > head').append(styleTag);
    }

    if ((settings.deviceHeightStyleVar != false) && ($("#deviceHeightStyleVar").length < 1)) {
        var rescaledHeight = "calc(100vh * " + 1 / scaleRatio + ")";
        var styleTag = $(`
            <style id="deviceHeightStyleVar">
                :root {
                    ${settings.deviceHeightStyleVar}: ${rescaledHeight};
                    ${settings.deviceScaleRatioStyleVar}: ${scaleRatio}
                }
            </style>
        `);
        $('html > head').append(styleTag);
    }

    $(settings.elScale.desktop + ", " + settings.elScale.mobile).each(async function () {
        const $el = $(this);
        const isMobile = config.func.isMobile();

        const scaleOrigin = () => {
            const originAttr = isMobile ? settings.dataOrigin.mobile : settings.dataOrigin.desktop;
            return $el.attr(originAttr) || 'top left';
        };

        const getDisplay = () => {
            const displayAttr = isMobile ? settings.dataDisplay.mobile : settings.dataDisplay.desktop;
            return $el.attr(displayAttr) || 'block';
        };

        const hasCorrectClass = () => {
            const targetClass = (isMobile ? settings.elScale.mobile : settings.elScale.desktop).replace(".", "");
            return $el.hasClass(targetClass);
        };

        if (!hasCorrectClass()) return;

        let transformCSS;
        const fullHeight = 1000 + (1000 - 1000 * scaleRatio);

        if (varMS.H5) {
            $('#MS__wrapper, .MS__outer').css("left", "50%");
            $('.MS__outer').css({
                "overflow": "hidden",
                "height": fullHeight
            });
            transformCSS = `scale(${scaleRatio}) translateX(-50%)`;
        } else {
            $('.MS__outer').css("height", $("body").innerHeight());
            transformCSS = `scale(${scaleRatio})`;
        }
        console.log("isMobile: ", isMobile);
        const width = isMobile ? config.widthMobile : config.widthDesktop;
        $el.css({
            width: `${width}px`,
            transform: transformCSS,
            marginLeft: `${marginLeft}px`,
            transformOrigin: scaleOrigin(),
            // display: getDisplay() // Uncomment nếu muốn xử lý display luôn
        });

       
        $('.MJ__readyScale').css('z-index', 'unset');
        $('.MJ__readyScale').removeClass('MJ__readyScale');
        $('.MS__layer-loading, .layer').hide();

        
        if (varMS.callbacks?.scaleRoot instanceof Function) {
            await varMS.callbacks.scaleRoot();
        };
        if (callback) {
            console.log('run Callback scaleRoot.')
             await callback()
        }
        // observe();
    });


    if (settings.rescaleForParent) {
        var obj = {
            height: settings.obj.outerHeight()
        }
        var scaleHeight = obj.height * scaleRatio;
        // console.log(scaleHeight, obj.height, scaleRatio);
        $(settings.obj).parent().css({

            height: scaleHeight + "px",
            // width: device.width+"px"
        })
    }

    $(settings.obj).parent().attr(settings.dataScale, scaleRatio);
    $(settings.obj).parent().attr(settings.dataDevice, (isMobile()) ? "mobile" : "desktop");
}